export default __webpack_public_path__ + "static/cekmekoy-rest-3-437d69ad08e276b10f658b79bcab68ad.jpg";